import { render, staticRenderFns } from "./EventRegisteredList.vue?vue&type=template&id=5decad5f&"
import script from "./EventRegisteredList.vue?vue&type=script&lang=ts&"
export * from "./EventRegisteredList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports